var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCssGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 125,
    rx: 15,
    fill: "#97D3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3799 113L33.4475 104.968L27 32.6523H97.8465L91.3922 104.957L62.3799 113Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8667 100.353L91.3823 38.5651H62.4233V106.852L85.8667 100.353Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7806 65.386L42.5756 74.2552H62.4232V65.386H41.7806Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1835 47.4346L40.9897 56.304H62.4233V47.4346H40.1835Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4232 88.4205L62.3844 88.4309L52.5066 85.7637L51.8752 78.6901H42.9719L44.2144 92.616L62.3824 97.6596L62.4232 97.6483V88.4205Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6732 13H54.4154V17.4922H48.1654V21.9844H54.4154V26.4766H43.6732V13Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5638 13H67.306V16.9062H61.056V17.6875H67.306V26.6719H56.5638V22.5703H62.8138V21.7891H56.5638V13Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4546 13H80.1967V16.9062H73.9467V17.6875H80.1967V26.6719H69.4546V22.5703H75.7046V21.7891H69.4546V13Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.009 65.3862L84.6102 47.4346H62.3926V56.304H74.8903L74.0832 65.3862H62.3926V74.2553H73.3141L72.2846 85.7581L62.3926 88.428V97.6553L80.575 92.6161L80.7084 91.1176L82.7926 67.7678L83.009 65.3862Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssGroup);
export default __webpack_public_path__ + "static/media/CSSGroup.e6ed60cbff303a6611ff936fb0bca743.svg";
export { ForwardRef as ReactComponent };